//images
import ev_charger_tester from "../Assets/ev_charger_tester.png";
import ev_simulator from "../Assets/ev_simulator.png";
import wallbox from "../Assets/wallbox.png";
import wallbox_pedestal from "../Assets/wallbox_pedestal.png";
import wallbox_double from "../Assets/wallbox_double.png";
import wallbox_payments from "../Assets/wallbox_payments.png";
import portable from "../Assets/portable.png";
import publicStation from "../Assets/public.png";
import portable_plus from "../Assets/portable_plus.png";
import accesory from "../Assets/accesory.png";
import ccs1_ccs2 from "../Assets/ccs1_ccs2.png";
import t1_t2 from "../Assets/t1_t2.png";
import t1_gbt_small from "../Assets/t1_gbt_small.png";
import t2_t1 from "../Assets/t2_t1.png";
import vtol from "../Assets/vtol.png";
import vtol_converter from "../Assets/vtol_converter.png";
import chademo_gbt from "../Assets/chademo_gbt.png";
import wallkit from "../Assets/wallkit.png";

//renders
import rwallbox from "../Assets/renders/wallbox.png";
import rwallbox_pedestal from "../Assets/renders/wallbox_pedestal.png";
import rportable from "../Assets/renders/portable.png";
import rportable_plus from "../Assets/renders/portable_plus.png";
import rccs1_ccs2 from "../Assets/renders/ccs1_ccs2.png";
import rt1_t2 from "../Assets/renders/t1_t2.png";
import rt1_gbt from "../Assets/renders/t1_gbt.png";
import rpublic from "../Assets/renders/public.png";
import rwallkit from "../Assets/renders/wallkit.png";
import rtester from "../Assets/renders/tester.png";

//DICTIONARIES

export const connectors = ["SAE-J1772", "Tipo 2", "GB/T"];

export const powerConfig = ["L2", "Dual"];

export const powerKws = ["7.6", "9.6", "11"];

export const tsjInterfaces = ["Agujero detrás", "Estándar", "EMT"];

export const powerCordConnectors = ["NEMA", "Sin NEMA", "Otro"];

// PRODUCTS
export const existingRenders = [
  "Estación Tipo Wallbox",
  "Estación Tipo Wallbox con pedestal",
  "Estación Tipo Wallbox con método de pago",
  "Estación Pública",
  "Estación Portátil Plus",
  "Estación Portátil",
  "Estación Portátil Dual",
  "Adaptador CCS1 a CCS2",
  "Adaptador Tipo 1 a GB/T",
  "Adaptador Tipo 1 a Tipo 2",
  "Kit de pared",
  "Probador de Estaciones",
];

//Function to select adapter type image
export const selectProductImage = (productName) => {
  switch (productName) {
    case "Estación Tipo Wallbox":
      return wallbox;
    case "Estación Pública":
      return publicStation;
    case "Estación Portátil Plus":
      return portable_plus;
    case "Estación Portátil":
      return portable;
    case "Estación Portátil Dual":
      return portable;
    case "Estación Tipo Wallbox con pedestal":
      return wallbox_pedestal;
    case "Estación Tipo Wallbox con método de pago":
      return wallbox_payments;
    case "Estación Tipo Wallbox doble":
      return wallbox_double;
    case "Adaptador Tipo 1 a Tipo 2":
      return t1_t2;
    case "Adaptador Tipo 2 a Tipo 1":
      return t2_t1;
    case "Adaptador Tipo 1 a GB/T":
      return t1_gbt_small;
    case "Adaptador CCS1 a CCS2":
      return ccs1_ccs2;
    case "Adaptador ChaDeMO a GB/T":
      return chademo_gbt;
    case "Probador de Estaciones":
      return ev_charger_tester;
    case "Simulador de Estación":
      return ev_simulator;
    case "Extensión VTOL":
      return vtol;
    case "Convertidor VTOL":
      return vtol_converter;
    case "Kit de pared":
      return wallkit;
    default:
      return accesory;
  }
};

//Function to select adapter type image
export const selectProductRender = (productName) => {
  switch (productName) {
    case "Estación Tipo Wallbox":
      return rwallbox;
    case "Estación Tipo Wallbox con pedestal":
      return rwallbox_pedestal;
    case "Estación Tipo Wallbox con método de pago":
      return rwallbox_pedestal;
    case "Estación Pública":
      return rpublic;
    case "Estación Portátil Plus":
      return rportable_plus;
    case "Estación Portátil":
      return rportable;
    case "Estación Portátil Dual":
      return rportable;
    case "Adaptador CCS1 a CCS2":
      return rccs1_ccs2;
    case "Adaptador Tipo 1 a GB/T":
      return rt1_gbt;
    case "Adaptador Tipo 1 a Tipo 2":
      return rt1_t2;
    case "Kit de pared":
      return rwallkit;
    case "Probador de Estaciones":
      return rtester;
    default:
      return null;
  }
};

export const assembly = [
  "Estación Portátil",
  "Estación Portátil Dual",
  "Estación Portátil Plus",
  "Estación Tipo Wallbox",
  "Estación Tipo Wallbox Plus",
  "Estación Tipo Wallbox con pedestal",
  "Estación Tipo Wallbox con método de pago",
  "Estación Tipo Wallbox doble",
  "Estación Pública",
  "Probador de Estaciones",
];

export const evstations = [
  "Estación Portátil",
  "Estación Portátil Dual",
  "Estación Portátil Plus",
  "Estación Tipo Wallbox",
  "Estación Tipo Wallbox Plus",
  "Estación Tipo Wallbox con pedestal",
  "Estación Tipo Wallbox con método de pago",
  "Estación Tipo Wallbox doble",
  "Estación Pública",
  "Cargador Portátil Dual (Genérico)"
];
